<script setup>
import {computed} from "vue";

const props = defineProps(['message']);

const messageMainPart = computed(() => {
    const words = props.message.split(' ');
    return words.length > 1 ? words.slice(0, -1).join(' ') + ' ' : '';
});

const messageLastWord = computed(() => {
    const words = props.message.split(' ');
    return words[words.length - 1];
});
</script>

<template>
    <div class="ai-loader">
        <span>{{messageMainPart}}
            <span style="white-space: nowrap;">
                {{messageLastWord}}
                <span class="ai-loader__circle ml-2"></span>
                <span class="ai-loader__circle"></span>
                <span class="ai-loader__circle"></span>
            </span>
        </span>
    </div>
</template>

<style scoped>

</style>
